import React, { useEffect } from 'react';

/**
 * Sends the browser to an address on another site.
 *
 * react-router's <Navigate> only moves within this app, so it cannot express
 * "this document is published somewhere else". A fresh request for these paths
 * never reaches React at all — nginx answers it with a 301 (see nginx.conf).
 * This covers the other way in: a link followed inside the running app, or an
 * old bundle still holding a route that has since moved.
 */
const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    // replace(), not assign(): the redirect must not sit in the history stack,
    // or Back would bounce the visitor straight out again.
    window.location.replace(to);
  }, [to]);

  return (
    <p className="p-8 text-sm text-gray-600 dark:text-slate-400">
      Redirecting to{' '}
      <a href={to} className="text-blue-600 hover:underline dark:text-blue-400">
        {to}
      </a>
      …
    </p>
  );
};

export default ExternalRedirect;
